import { useTranslation } from 'react-i18next'

export default function UserCountBadge() {
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-center gap-2 py-2">
      <div className="flex -space-x-2">
        {['🧑', '👩', '👨', '👩‍🦰', '🧑‍🦱'].map((emoji, i) => (
          <span
            key={i}
            className="bg-primary/10 flex h-8 w-8 items-center justify-center rounded-full border-2 border-white text-sm"
          >
            {emoji}
          </span>
        ))}
      </div>
      <p className="text-sm font-medium text-[#9699AE]">
        {t('pages.checkout.userCount')}
      </p>
    </div>
  )
}
